$(document).ready(function(){
  // -- forgot password --
  $('.showForgotPassword').on('click', function(e){
    e.preventDefault();
    $('.signInFormWrapper').fadeOut('fast');
    $('.forgotPasswordWrapper').delay(200).fadeIn('slow');
    $('.form__notifications .success, .form__notifications .error').html('').fadeOut();
  });

  $('.hideForgotPassword').on('click', function(e){
    e.preventDefault();
    $('.forgotPasswordWrapper').fadeOut('fast');
    $('.signInFormWrapper').delay(200).fadeIn('slow');
    $('.form__notifications .success, .form__notifications .error').html('').fadeOut();
  });


  // -- craft cms form --
  var form = $('.craftForm');
  form.on('submit', function(e) {
    e.preventDefault();
    var data = $(this).serialize();

    // -- Remove any existing error messages from previous attempts --
    $('html, body').animate({scrollTop: $('body').offset().top - 117}, 'slow');
    if (form.hasClass('bookingForm')) {
      $('.form__notifications .success, .form__notifications .error').fadeOut();
    } else {
      $('.form__notifications .success, .form__notifications .error').html('').fadeOut();
    }

    $.ajax({
      type: 'post',
      url: window.location.origin + '/' + $('html').attr('lang') + '/',
      dataType: 'json',
      data: data,
      beforeSend: function(response) {
        form.find('input[type=submit]').prop('disabled', true);
      },
      success: function(response) {
        console.log(response);
        if (response.success) {
          console.log('success');
          // -- Display notifications --
          if (form.hasClass('shareByEmailForm')) {
            $('.form__notifications .success').text(response.message).delay(400).fadeIn();
            setTimeout(function(){
              $('.popup').removeClass('open');
            },2500);
          } else if (form.hasClass('bookingForm')) {
            $('.form__notifications .success').delay(400).fadeIn();
          } else {
            window.location.href = form.find('input[name="redirect"]').val();
          }
        } else {
          console.log('error');
          // -- Display notifications --
          if (form.hasClass('shareByEmailForm')) {
            $('.form__notifications .error').text(response.message).delay(400).fadeIn();
          } else if (response.errors) {
          	$('.form__notifications .error').append('<ul></ul>');
          	$.map(response.errors, function(value,key) {
          	  var li = '<li>'+value+'</li>';
          	  $('.form__notifications .error ul').append(li);
          	});
        	  $('.form__notifications .error').delay(400).fadeIn();
          } else {
          	$('.form__notifications .error').text(response.error).delay(400).fadeIn();
          }
        }
      },
      error: function(response){
        console.log(response);
        if (form.hasClass('bookingForm')) {
          $('.form__notifications .error').delay(400).fadeIn();
        }
      },
      complete: function(response) {
        form.find('input[type=submit]').prop('disabled', false);
      }
    });

  });


  // -- booking form | guided tour --
  $('.types input').on('change', function(){
    var value = $(this).attr('data-val');
    if (value == 'guided_tour') {
      $('.type--selfGuided').addClass('hidden');
      $('.type--guided').removeClass('hidden');
      $('.type--guided input.required').prop('required', true);
    } else if (value == 'self_guided') {
      $('.type--selfGuided').removeClass('hidden');
      $('.type--guided').addClass('hidden');
      $('.type--guided input.required').prop('required',false);
    }
  });

});
